import CustomInput from "../CustomInput";
import { ReactComponent as Search } from 'assets/common/searchW.svg'
import CustomButton from "../CustomButton";
import { ReactComponent as Close } from 'assets/header/close.svg'
import { useSetAtom } from "jotai";
import { hsCodeResultAtom } from "atom/hsCode";
import { useState } from "react";
import { toast } from "react-toastify";
import { jsonAxios } from "components/axios";
import { ReactComponent as Del } from 'assets/quote/del.svg'
import { IQuote } from "types/quote";
import InfoArea from "components/solomonShip/tab/quote/InfoArea";
import InfoAreaTable from "components/solomonShip/tab/quote/InfoAreaTable";
import InfoAreaFile from "components/solomonShip/tab/quote/InfoAreaFile";

interface IHsCodeModal {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    quoteInfo: IQuote
    fileArr?: File[]
}

const ConfrimChatQuote = ({ isOpen, setIsOpen, quoteInfo, fileArr }: IHsCodeModal) => {
    const tHeader = [
        { label: "No.", flex: 0.5, type: '' },
        { label: "CNTR", flex: 1, type: '' },
        { label: "G.Weight", flex: 1, type: '' },
        { label: "수량", flex: 1, type: '' },
    ];

    const close = () => {
        setIsOpen(false)
    }

    if (!isOpen) return null;

    return (
        <div className="z-[100] fixed">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg p-6 rounded-lg w-[660px] tablet:w-96 max-h-[80vh] overflow-y-auto text-black">
                    <div className='flex flex-col gap-6 font-semibold text-center'>
                        <div className='flex flex-col items-start gap-3'>
                            <div className="flex justify-between items-center mb-6 w-full">
                                <p className='text-2xl'>내용확인</p>
                                <Close className='cursor-pointer' onClick={() => {
                                    close();
                                }
                                } />
                            </div>
                            <div className="w-full">
                                <InfoArea
                                    title='출발지'
                                    value={`${quoteInfo.step1?.originCode} | ${quoteInfo.step1?.originAddress}`}
                                />
                                <InfoArea
                                    title='도착지'
                                    value={`${quoteInfo.step1?.destinationCode} | ${quoteInfo.step1?.destinationAddress}`}
                                />
                                <InfoArea
                                    title='화물 출고일'
                                    value={quoteInfo?.isShippingDate ? '출고일확정' : '출고일미정'}
                                />
                                {
                                    quoteInfo?.shippingDate &&
                                    <InfoArea
                                        title=''
                                        value={quoteInfo?.shippingDate ?? ''}
                                    />
                                }
                                <InfoArea
                                    title='운송 유형'
                                    value={quoteInfo.step2.shipmentMode}
                                />
                                <InfoArea
                                    title='HS CODE'
                                    value={quoteInfo.step2?.hsCode}
                                />
                                {
                                    quoteInfo?.step2?.shipmentMode === 'FCL' &&
                                    <InfoAreaTable
                                        title='화물정보'
                                    >
                                        <div className='flex bg-[#F8F8FA] border-[#9D9EB7] border-t-1 font-semibold text-sm'>
                                            {
                                                tHeader.map((item, idx) => (
                                                    <div
                                                        key={idx}
                                                        className={`flex-[${item.flex}] flex items-center justify-center h-10 ${idx === 0 ? 'tablet:hidden' : ''} text-center`}
                                                    >
                                                        {item.label}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        {
                                            quoteInfo?.step2.containerList.map((item, idx) => (
                                                <div
                                                    className={`flex h-15 font-semibold text-sm ${idx === quoteInfo?.step2?.containerList?.length - 1 ? 'border-b-1 border-[#9D9EB7]' : ''} `}
                                                    key={idx}>
                                                    <div className='tablet:hidden flex flex-[0.5] justify-center items-center'>{idx + 1}</div>
                                                    <div className='flex flex-[1] justify-center items-center'>
                                                        {item.containerType}
                                                    </div>
                                                    <div className='flex flex-[1] justify-center items-center'>
                                                        {Number(item.containerWeight).toLocaleString()} Kg
                                                    </div>
                                                    <div className='flex flex-[1] justify-center items-center'>
                                                        {item.containerQuantity}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </InfoAreaTable>
                                }
                                {
                                    fileArr &&
                                    fileArr.length > 0 &&
                                    <InfoAreaFile
                                        title='첨부서류'
                                        file={fileArr}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfrimChatQuote;